import React, { useEffect, useRef, useState } from 'react'

import { Header } from 'components'
import { TTagging } from 'interface'
import { useApplicationCtx } from 'context/application'
import { tagEvent } from 'utils/tagging'
import { IBuyCardHolder, IBuyInfo, ImobileRefs, LatLng } from 'types'
import { useQuery } from 'react-query'
import BuyInfo from 'components/BuyInfo'
import { useSearchParams } from 'react-router-dom'
import Maps from 'components/Maps/Maps'

import InterWebviewBridge, { IWbHttpData } from '@interco/inter-webview-bridge'
import { BottomSheet } from '@interco/inter-ui/components/BottomSheet'
import { Button } from '@interco/inter-ui/components/Button'

import * as S from './styles'

function Home() {
  const [searchParams] = useSearchParams()
  const mobileRefs = useRef<ImobileRefs>({
    transactionId: searchParams.get('id'),
    entryMode: searchParams.get('entryMode'),
    steps: {
      num: Number(searchParams.get('currentStep')),
      totalSteps: Number(searchParams.get('totalStep')),
    },
  })

  const iWb = InterWebviewBridge.getInstance()

  const { showBottomSheet, setShowBottomSheet } = useApplicationCtx()
  const { httpHandler } = useApplicationCtx()
  const request = {
    url: `/app/meios-pagamentos/v1/cards/contestation/ethoca/${mobileRefs.current?.transactionId}`,
    method: 'GET',
  }

  const [userLocation, setUserLocation] = useState<LatLng | null>(null)

  const handleSearch = async () => {
    try {
      const { response } = (await httpHandler.get(request.url)) as IWbHttpData
      return response as unknown as IBuyInfo
    } catch (error) {
      throw new Error('Failed to fetch data')
    }
  }

  const ethocaInfos = useQuery<IBuyInfo>('ethoca', handleSearch, {
    enabled: false,
    select(response) {
      if (typeof response === 'string') {
        return JSON.parse(response)
      }
      return response
    },
    onSuccess: (data) => {
      if (data?.merchant?.location && Object.keys(data?.merchant?.location).length) {
        setUserLocation((prevState) => ({
          ...prevState,
          lat: Number(data?.merchant?.location?.latitude),
          lng: Number(data?.merchant?.location?.longitude),
        }))
      }
    },
  })

  const haveRecibo = (() => {
    const purchaseReceipt = ethocaInfos.data?.purchaseReceipt
    if (purchaseReceipt && typeof purchaseReceipt === 'object') {
      return 'url' in purchaseReceipt
    }
    return false
  })()

  useEffect(() => {
    tagEvent({
      type: 'ETHOCA_FLUXO_ACESSO',
      screen: 'card-webview-ethoca-contestation',
      content_action: 'Dado carregado',
      action_id: 'dado_carregado',
    } as TTagging)
    ethocaInfos.refetch()
  }, [])

  async function exitWebView(param: IBuyCardHolder | null) {
    const navigateToMobile = await iWb.execute({
      action: 'navigateToNativeMPScreen',
      metadata: {
        screen: 'INFORMATIVO_CONTESTACAO',
        parameters: {
          cardAccount: param?.cardAccount,
          cardIdProc: param?.cardIdProc,
          cardNumber: param?.cardNumber,
          entryMode: mobileRefs.current?.entryMode,
          transactionId: mobileRefs.current?.transactionId,
        },
      },
    })
    return navigateToMobile
  }

  return (
    <S.Wrapper>
      {ethocaInfos.isSuccess && (
        <>
          <Header title="Detalhes da compra" progress={mobileRefs.current.steps} />
          <S.Sections>
            <BuyInfo
              progress={mobileRefs.current.steps ?? null}
              merchant={ethocaInfos.data.merchant ?? null}
              transactionAmount={ethocaInfos.data.transactionAmount ?? null}
              urlToNavigate={ethocaInfos.data?.purchaseReceipt?.url ?? null}
              haveRecibo={haveRecibo}
            />
            {userLocation && Object.keys(userLocation).length > 0 && (
              <Maps userLocation={userLocation} />
            )}
            {showBottomSheet && (
              <BottomSheet onClose={() => setShowBottomSheet(false)}>
                <S.ContainerIFrame>
                  {ethocaInfos.data?.purchaseReceipt?.url ? (
                    <iframe
                      title="Recibo Mastercard Ethoca"
                      width="100%"
                      height={600}
                      loading="lazy"
                      style={{ border: 'none' }}
                      src={ethocaInfos.data?.purchaseReceipt?.url}
                    />
                  ) : (
                    <div style={{ display: 'flex', justifyContent: 'center', padding: '3rem 0px' }}>
                      <Button disabled variant="secondary">
                        Recibo não disponível
                      </Button>
                    </div>
                  )}
                </S.ContainerIFrame>
              </BottomSheet>
            )}
            <Button
              style={{ zIndex: '1001' }}
              onClick={() => {
                exitWebView(ethocaInfos.data?.cardHolder ?? null)
                tagEvent({
                  type: 'ETHOCA_FLUXO_ACESSO',
                  screen: 'card-webview-ethoca-contestation',
                  content_action: 'Toque',
                  product: 'contestacao_ethoca',
                  action_id: 'Continuar',
                } as TTagging)
              }}
            >
              Continuar
            </Button>
          </S.Sections>
        </>
      )}
    </S.Wrapper>
  )
}

export default Home
